import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { getGridClasses } from '../Grid/GridPresentation.js';
import { getGridRowClasses } from '../GridRow/GridRowPresentation.js';
import { hostClass } from './Cards.styles.js';

var defaultProps = {};
var CardsPresentation = fComp(function (props) {
  var _cleanupClassObject;
  var id = props.id,
    children = props.children,
    className = props.className,
    noMargin = props.noMargin,
    isStencilHost = props.isStencilHost,
    centeredLayout = props.centeredLayout;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, getGridClasses({
      spacing: "subsection",
      centeredLayout: centeredLayout
    }), true), _cleanupClassObject)),
    isStencilHost: isStencilHost,
    role: "group"
  }, /*#__PURE__*/React.createElement("div", {
    className: getGridRowClasses({}),
    key: "selection-card-row"
  }, children));
}, defaultProps);
CardsPresentation.displayName = "CardsPresentation";

export { CardsPresentation, defaultProps };
